"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDisplayItemValue = void 0;
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var value_1 = require("./value");
function SchemaDisplayItemValue(props) {
    var name = props.name, schema = props.schema, values = props.values, size = props.size, color = props.color, weight = props.weight;
    var field = (0, get_1.default)(schema, (0, utils_1.getNestedFieldNameSchemaProperty)(name));
    // When there is no type it means it is a hidden field.
    if (!field || !field.inputType)
        return null;
    var inputMetadata = field.inputMetadata, inputType = field.inputType;
    var fieldValue = (0, utils_1.getFieldValue)(name, values);
    return react_1.default.createElement(value_1.Value, { name: name, field: field, value: fieldValue, size: size, color: color, weight: weight });
}
exports.SchemaDisplayItemValue = SchemaDisplayItemValue;
